import script from "./partnerEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./partnerEdit.vue?vue&type=script&setup=true&lang=js"

import "./partnerEdit.vue?vue&type=style&index=0&id=f78eee52&lang=scss&scoped=true"
import "./partnerEdit.vue?vue&type=style&index=1&id=f78eee52&lang=css"

import exportComponent from "D:\\workCode\\web-middleground\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f78eee52"]])

export default __exports__